import React, { useEffect, useRef, useState, useContext } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import axios from "axios";
import AppContext from "../../../context/AppContext";
import "../../../assets/css/gcstudent/footer/Footer.css";

const quickLinks = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "Library", path: "/library" },
  { label: "Digital Library", path: "/digital-library" },
  { label: "Notes", path: "/notes" },
  { label: "Blogs", path: "/blogs" },
];

// const resources = [
//   { label: "Student Portal", path: "/student/dashboard" },
//   { label: "Teacher Portal", path: "/teacher/dashboard" },
//   { label: "Admin Panel", path: "/admin/dashboard" },
//   { label: "ContactUs", path: "/contact" },
// ];

const Footer = () => {
  const { baseUrl } = useContext(AppContext);

  const [isVisible, setIsVisible] = useState(false);
  const footerRef = useRef(null);

  // fallback values jab tak API se library info na aaye
  const [libraryInfo, setLibraryInfo] = useState({
    email: "info@ggcwlibrary.edu.pk",
    phone: "+92 300 1234567",
    address: "Govt Graduate College for Women Sattelite Town Gujranwala",
  });

  // Admin ke Settings > Library Config se jo save hota hai, wahi yahan load hota hai
  useEffect(() => {
    axios
      .post(`${baseUrl}/contact/getLibraryInfo`, {})
      .then((res) => {
        if (res.data.success && res.data.libraryConfig) {
          setLibraryInfo((prev) => ({
            email: res.data.libraryConfig.email || prev.email,
            phone: res.data.libraryConfig.phone || prev.phone,
            address: res.data.libraryConfig.address || prev.address,
          }));
        }
      })
      .catch((err) => console.log(err));
  }, [baseUrl]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.08 }
    );
    if (footerRef.current) observer.observe(footerRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <footer className="gcStudent-footer" ref={footerRef}>

      {/* Ghost Watermark */}
      <span className="gcStudent-footer-watermark" aria-hidden="true">
        GGCW Library
      </span>

      <Container>
        {/* ── Top Grid ── */}
        <Row className="gcStudent-footer-top-row">

          {/* Col 1 — Brand */}
          <Col xs={12} md={6} lg={3}
            className={`gcStudent-footer-col ${isVisible ? "gcStudent-footer-col--visible" : ""}`}
            style={{ transitionDelay: "0.05s" }}
          >
            <div className="gcStudent-footer-brand">
              {/* <div className="gcStudent-footer-logo-box">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div> */}
              <span className="gcStudent-footer-brand-name">GGCW Library</span>
            </div>
            <p className="gcStudent-footer-desc">
              A modern digital library management system designed to make book
              access and management seamless for students, staff, and
              administrators.
            </p>
          </Col>

          {/* Col 2 — Quick Links */}
          <Col xs={6} md={3} lg={2}
            className={`gcStudent-footer-col gcStudent-footer-col--links ${isVisible ? "gcStudent-footer-col--visible" : ""}`}
            style={{ transitionDelay: "0.14s" }}
          >
            <h6 className="gcStudent-footer-heading">Quick Links</h6>
            <ul className="gcStudent-footer-list">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <NavLink to={link.path} className="gcStudent-footer-link">
                    {link.label}
                  </NavLink>
                </li>
              ))}
            </ul>
          </Col>

          {/* Col 3 — Resources
          <Col xs={6} md={3} lg={2}
            className={`gcStudent-footer-col ${isVisible ? "gcStudent-footer-col--visible" : ""}`}
            style={{ transitionDelay: "0.23s" }} */}
          {/* > */}
            {/* <h6 className="gcStudent-footer-heading">Resources</h6>
            <ul className="gcStudent-footer-list">
              {resources.map((item) => (
                <li key={item.label}>
                  <NavLink to={item.path} className="gcStudent-footer-link">
                    {item.label}
                  </NavLink>
                </li>
              ))}
            </ul>
          </Col> */}

          {/* Col 4 — Contact Info */}
          <Col xs={12} md={6} lg={3}
            className={`gcStudent-footer-col ${isVisible ? "gcStudent-footer-col--visible" : ""}`}
            style={{ transitionDelay: "0.32s" }}
          >
            <h6 className="gcStudent-footer-heading">Contact Info</h6>
            <ul className="gcStudent-footer-contact-list">
              <li className="gcStudent-footer-contact-item">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" className="gcStudent-footer-contact-svg">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" stroke="rgba(255,255,255,0.6)" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                  <polyline points="22,6 12,13 2,6" stroke="rgba(255,255,255,0.6)" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                <span className="gcStudent-footer-contact-text">{libraryInfo.email}</span>
              </li>
              <li className="gcStudent-footer-contact-item">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" className="gcStudent-footer-contact-svg">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.4 2 2 0 0 1 3.6 1.22h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.82a16 16 0 0 0 6 6l.95-.96a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" stroke="rgba(255,255,255,0.6)" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                <span className="gcStudent-footer-contact-text">{libraryInfo.phone}</span>
              </li>
              <li className="gcStudent-footer-contact-item">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" className="gcStudent-footer-contact-svg">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" stroke="rgba(255,255,255,0.6)" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                  <circle cx="12" cy="10" r="3" stroke="rgba(255,255,255,0.6)" strokeWidth="1.8" />
                </svg>
                <span className="gcStudent-footer-contact-text">{libraryInfo.address}</span>
              </li>
            </ul>
          </Col>
        </Row>

        {/* ── Divider ── */}
        <div className={`gcStudent-footer-divider ${isVisible ? "gcStudent-footer-divider--visible" : ""}`} />

        {/* ── Copyright Bar ── */}
        <div className={`gcStudent-footer-bottom ${isVisible ? "gcStudent-footer-bottom--visible" : ""}`}>
          <p className="gcStudent-footer-copy">
            &copy; 2026 GGCW Library. All rights reserved. Digital Library Management System.
          </p>
        </div>
      </Container>

    </footer>
  );
};

export default Footer;